import { render, staticRenderFns } from "./EditSystemInfo.vue?vue&type=template&id=0c64fb32"
import script from "./EditSystemInfo.vue?vue&type=script&lang=js"
export * from "./EditSystemInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports